import React from 'react';
import { Link } from 'react-router-dom';

const ProductCard = ({ product }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'In Stock': return 'text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-500/10';
      case 'Low Stock': return 'text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-500/10';
      case 'Out of Stock': return 'text-rose-600 dark:text-rose-400 bg-rose-50 dark:bg-rose-500/10';
      default: return 'text-gray-600 dark:text-gray-400 bg-gray-50 dark:bg-gray-800/10';
    }
  };

  const imageUrl = product.image && product.image !== '' ? product.image : 'https://via.placeholder.com/400x400?text=No+Image';

  return (
    <Link to={`/product/${encodeURIComponent(product.id)}`} className="group flex flex-col bg-white dark:bg-gray-900 border border-gray-100 dark:border-gray-800 hover:border-gray-300 dark:hover:border-gray-700 rounded-xl overflow-hidden transition-all duration-200 hover:shadow-sm">
      <div className="aspect-square w-full overflow-hidden bg-gray-50 dark:bg-gray-800 relative transition-colors">
        <img src={imageUrl} alt={product.title} className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-300" />
        <div className="absolute top-3 right-3">
          <span className={`text-[10px] font-medium px-2 py-1 rounded-full uppercase tracking-wider border border-transparent ${getStatusColor(product.status)}`}>
            {product.status}
          </span>
        </div>
      </div>
      <div className="p-4 flex flex-col flex-grow">
        <div className="text-xs text-gray-400 dark:text-gray-500 mb-1 font-mono">{product.sku}</div>
        <h3 className="text-sm font-medium text-gray-900 dark:text-white mb-2 line-clamp-2 min-h-[40px] transition-colors">{product.title}</h3>
        <div className="mt-auto flex items-center justify-between text-sm">
          <span className="text-gray-500 dark:text-gray-400">{product.stock} units</span>
          <span className="font-medium text-gray-900 dark:text-white font-mono">${(product.price || 0).toFixed(2)}</span>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;